import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadCurrentBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadCurrentBillTo";
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    loadCurrentShipTo,
    loadCurrentBillTo,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
const mapStateToProps = (state: ApplicationState) => ({
    currentBillTo: getCurrentBillToState(state),
    currentShipTo: getCurrentShipToState(state),
    email: state.context.session.email,
    session: state.context.session,
});

const ChatBot = ({ currentBillTo, currentShipTo, email, loadCurrentShipTo, loadCurrentBillTo, session }: Props) => {
    const isAuthenticated = session && session.isAuthenticated && !session.rememberMe && !session.isGuest;
    if (!isAuthenticated) {
        return null;
    }

    const hasAllInformation = !!(currentBillTo?.value && currentShipTo?.value && email);

    useEffect(() => {
        if (isAuthenticated && !currentShipTo.value && !currentShipTo.isLoading) {
            loadCurrentShipTo();
        }

        if (isAuthenticated && !currentBillTo.value && !currentBillTo.isLoading) {
            loadCurrentBillTo();
        }
    }, []);

    useEffect(() => {
        if (hasAllInformation) {
            const script = document.createElement("script");
            script.src = "https://static.zdassets.com/ekr/snippet.js?key=3faa72a5-c256-4c3b-91bb-ec7fde0a80eb";
            script.async = true;
            script.id = "ze-snippet";
            script.onload = function () {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                zE("messenger", "close");
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                zE("messenger:set", "conversationFields", [{ id: 17847560878999, value: email }]);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                zE("messenger:set", "conversationFields", [
                    { id: 17847587606039, value: currentBillTo?.value?.customerNumber },
                ]);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                zE("messenger:set", "conversationFields", [
                    { id: 17847579840023, value: currentShipTo?.value?.customerSequence },
                ]);
            };
            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, [hasAllInformation]);

    return null;
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ChatBot),
    definition,
};

export default widgetModule;
